import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Pipe para sanitização de HTML.
 * 
 * @security ATENÇÃO: Este pipe bypassa a proteção XSS do Angular.
 * Utilize apenas com conteúdo HTML confiável e previamente validado.
 * 
 * @example
 * // No template
 * <div [innerHTML]="conteudoHTML | sanitizeHTML"></div>
 */
@Pipe({
    name: 'sanitizeHTML',
    standalone: false
})
export class SanitizeHTMLPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) { }

    transform(html: string): SafeHtml {
        if (!html) {
            return '';
        }
        // Lista de tags e atributos perigosos
        const padroesMaliciosos = [
            'script',
            'javascript:',
            'onerror=',
            'onload=',
            'onclick=',
            'data:text/html'
        ];

        const htmlLowerCase = html.toLowerCase();
        if (padroesMaliciosos.some(padrao => htmlLowerCase.includes(padrao))) {
            console.warn('Tentativa de injeção de script detectada');
            return '';
        }

        try {
            return this.sanitizer.bypassSecurityTrustHtml(html);
        } catch (error) {
            console.error('Erro ao sanitizar HTML:', error);
            return '';
        }
    }

}